export const required = text => v => !!v || text
export const email = text => v => /.+@.+\..+/.test(v) || text
export const maxLength = (num, text) => v => (v && v.length <= num) || text
export const minLength = (num, text) => v => (v && v.length >= num) || text
export const numberOnly = text => v => /^\d+$/.test(v) || text

export default {
  required,
  email,
  maxLength,
  minLength,
  numberOnly,
}